import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P003GetData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.UserService}p_user_profile_info`), body, authorization)
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P003CreateData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);   
            await axios.post(URL_API(`${servicelist.UserService}p_user_profile_update`), body, authorization) 
                .then(res => {
                    resolve(res);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P003CreatePhotoData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);   
            await axios.post(URL_API(`${servicelist.UserService}p_user_photo_update`), body, authorization) 
                .then(res => {
                    resolve(res);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


